/**
 * Procedure Categories and Procedures for MS / Diploma in Obstetrics & Gynaecology (MS OBGY) students
 * Extracted with strict evidence from official NMC PDF (Page 5-6: "Operative Skills in Obstetrics and Gynaecology")
 */
export const OBGY_PROCEDURES = {
  "Obstetric Operative & Delivery Procedures": [
    "Conduct Normal Deliveries",
    "Episiotomy and Episiotomy Repair",
    "Application of Forceps and Ventouse (Vacuum Delivery)",
    "Caesarean Section Delivery (LSCS)",
    "Manual Removal of Placenta (MROP)",
    "Repair & Management of Genital Tract Obstetrical Injuries",
    "Post Partum Sterilization / Minilap Tubal Ligation",
    "Medical Termination of Pregnancy (MTP - Various Methods)",
    "Venesection & Culdocentesis in Obstetrics",
  ],
  "Gynaecological Surgical & Biopsy Procedures": [
    "Endometrial & Cervical Biopsy",
    "Dilatation and Curettage (D&C)",
    "Coldocentesis & Colpotomy",
    "Opening and Closing of Abdomen",
    "Surgical Operations for Pelvic Organ Prolapse",
    "Ovarian Cystectomy & Surgery for Ovarian Pathology",
    "Surgery for Ectopic Pregnancy",
    "Vaginal Hysterectomy & Abdominal Hysterectomy",
  ],
  "Diagnostic Gynaecological & Fetal Procedures": [
    "Vaginal Pap Smear Collection",
    "Colposcopy Examination & Biopsy",
    "Amniocentesis",
    "Diagnostic Laparoscopy & Hysteroscopy",
    "Obstetrical & Gynaecological Ultrasonography Performance",
  ],
};

export const OBGY_CATEGORIES = Object.keys(OBGY_PROCEDURES);

export const isDiplomaInOBGYDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    (
      d.includes("obgy") ||
      d.includes("dgo") ||
      d.includes("gynaecology") ||
      d.includes("gynecology") ||
      d.includes("obstetrics")
    ) &&
    !d.includes("oncology")
  );
};

export const isMSInOBGYDept = isDiplomaInOBGYDept;
